<template>
  <div class="component-attr-panel">
    <div class="controlTypeName">
    {{controlTypeName}}
    </div>
    <el-form ref="formProps" :model="component" class="component-attr" label-position="left" label-width="65px" @submit.native.prevent>
      <template v-for="(attr,index) in getComponentProps(component)">
        <component ref="componentAttr" :is="'attr-'+attr" :component='component' :currentNodeFormId="currentNodeFormId" :key="index + new Date().getTime()" @setOption="getOptions" :options="options"></component>
      </template>
    </el-form>

    <el-row class="btns">
      <el-button class="save" type="primary" @click="saveAttr">保存</el-button>
      <el-button class="close" type="comfirm" @click="closeAttr(1)">取消</el-button>
    </el-row>
  </div>
</template>

<script>
import {getProperties} from '@/store/form/componentDefaults.js'

import AttrName from '../componentAttr/name'
import AttrRequired from '../componentAttr/required'
import AttrReadonly from '../componentAttr/readonly'
import AttrHidden from '../componentAttr/hidden'
import AttrArchivedTable from '../componentAttr/archived-table'
import AttrArchived from '../componentAttr/archived'
import AttrHeight from '../componentAttr/height'
import AttrPlaceholder from '../componentAttr/placeholder'
import AttrAddress from '../componentAttr/address'
import AttrAlignment from '../componentAttr/alignment'
import AttrCol from '../componentAttr/col'
import AttrCurrencyType from '../componentAttr/currency-type'
import AttrRepeatability from '../componentAttr/repeatability'
import AttrSettingOption from '../componentAttr/setting-option'
import AttrDataSourcePrivide from '../componentAttr/data-source-privide'
import AttrDateType from '../componentAttr/date-type'
import AttrDiscern from '../componentAttr/discern'
import AttrLimit from '../componentAttr/limit'
import AttrMaxRowModule from '../componentAttr/max-row-module'
import AttrPostfix from '../componentAttr/postfix'
import AttrCode from '../componentAttr/code'
import AttrRelevance from '../componentAttr/relevance'
import AttrRowCol from '../componentAttr/row-col'
import AttrRow from '../componentAttr/row'
import AttrSearchChoose from '../componentAttr/search-choose'
import AttrSizex from '../componentAttr/sizex'
import AttrSizey from '../componentAttr/sizey'
import AttrThousand from '../componentAttr/thousand'
import AttrTime from '../componentAttr/time'
import AttrTriggerMode from '../componentAttr/trigger-mode'
import AttrUpload from '../componentAttr/upload.vue'
import AttrSettingValue from '../componentAttr/setting-value'
import AttrLabelContent from '../componentAttr/label-content'
import AttrHeightAdaptation from '../componentAttr/height-adaptation'
import AttrOcr from '../componentAttr/OCR'
import AttrDisableCopy from '../componentAttr/disable-copy'
import AttrDisablePaste from '../componentAttr/disable-paste'
import AttrDescribeMessage from '../componentAttr/describe-message'
import AttrIsOpen from '../componentAttr/is-open'
import AttrAddOptions from '../componentAttr/add-options'
import AttrLayout from '../componentAttr/layout'
import AttrReport from '../componentAttr/report'
import AttrBigFileUpload from '../componentAttr/big-file-upload'
import AttrImage from '../componentAttr/image'
import AttrFold from '../componentAttr/fold'
import AttrLockRow from '../componentAttr/lock-row'
import AttrCheckLine from '../componentAttr/check-line'

export default {
  name: 'ComponentAttr',
  props: ['originalComponent', 'currentNodeFormId'],
  inject: ['formService', 'componentEventBus'],
  data () {
    let component = this.$_.cloneDeep(this.originalComponent)
    return {
      component,
      options: [],
      controlTypeName: ''
    }
  },
  created () {
    //  生命周期影响。直接return getProperties时并没有这个方法
    this.controlTypeName = getProperties(this.component.componentType).defaults.name + '属性'
  },
  watch: {
    // 为了实现切换控件的属性也能切换
    'originalComponent.id' () {
      this.component = this.$_.cloneDeep(this.originalComponent)
      this.controlTypeName = getProperties(this.component.componentType).defaults.name + '属性'
    }
  },
  components: {
    AttrName,
    AttrRequired,
    AttrArchived,
    AttrHidden,
    AttrHeight,
    AttrReadonly,
    AttrPlaceholder,
    AttrArchivedTable,
    AttrRepeatability,
    AttrDateType,
    AttrDiscern,
    AttrMaxRowModule,
    AttrPostfix,
    AttrCode,
    AttrRelevance,
    AttrRowCol,
    AttrRow,
    AttrSearchChoose,
    AttrSizex,
    AttrSizey,
    AttrThousand,
    AttrTime,
    AttrTriggerMode,
    AttrAddress,
    AttrAlignment,
    AttrCol,
    AttrCurrencyType,
    AttrSettingOption,
    AttrDataSourcePrivide,
    AttrLimit,
    AttrSettingValue,
    AttrUpload,
    AttrLabelContent,
    AttrHeightAdaptation,
    AttrOcr,
    AttrDisableCopy,
    AttrDisablePaste,
    AttrDescribeMessage,
    AttrIsOpen,
    AttrAddOptions,
    AttrLayout,
    AttrReport,
    AttrBigFileUpload,
    AttrImage,
    AttrFold,
    AttrLockRow,
    AttrCheckLine
  },
  methods: {
    getOptions (options) {
      this.options = options
    },
    getComponentProps (component) {
      if (component) {
        let currentComponent = []
        currentComponent = getProperties(component.componentType)
        if (currentComponent) {
          return currentComponent.props
        }
      }
    },
    validate () {
      return this.$refs.formProps.validate()
    },
    saveAttr () {
      this.validate()
        .then(async () => {
          try {
            // FIXME: 重名校验应该由父元素检测, 子集是否同名.
            let componentList = this.bulidData()
            this.checkNameRepeat(componentList)
          } catch (error) {
            this.$message.warning(error.message)
          }
          this.$refs.componentAttr.forEach(m => {
            m.saveAttr && m.saveAttr()
          })
          let pinyin = await this.formService.getPinyinByHanzi(this.component.name)
          this.component.pinyinName = pinyin.pinyinName
          this.component.pinyinFirstChar = pinyin.pinyinFirstChar
          this.formService.updateAttr(this.component)
            .then(data => {
              if (data === 'next') {
                let table = this.formService.schema.getTable(this.component.archive.tableId)
                // 表格不需要改列的值
                if (this.component.componentType === 'rc-table') {
                  table.pinyinName = pinyin.pinyinName
                  table.pinyinFirstChar = pinyin.pinyinFirstChar
                } else {
                  if (table && table.columns) {
                    let c = table.columns.find(c => c.id === this.component.archive.columnId)
                    if (c) {
                      c.pinyinName = pinyin.pinyinName
                      c.pinyinFirstChar = pinyin.pinyinFirstChar
                    }
                  }
                }
                this.closeAttr()
              }
            })
        })
    },
    closeAttr (save = 0) {
      // 属性面板关闭的时候重新调用 loadDataReports 获取归档表数据
      this.formService.loadDataReports()
      this.componentEventBus.$emit('changeLeftPanel', { state: 'ComponentList', id: 'null', save })
    },
    bulidData (componment) {
      let originalcomponentList = this.formService.component.children
      let componentList = componment || this.$_.cloneDeep(originalcomponentList)
      componentList.forEach(el => {
        if (el.id === this.component.id) {
          el.name = this.component.name
          return
        }
        // 判断是否是表格控件 表格控件中也要判重
        if (el.children && el.children.length && el.children.length > 0) {
          this.bulidData(el.children)
        }
      })
      return componentList
    },
    checkNameRepeat (componment) {
      let componentList = componment
      let originalComponent = this.component
      componentList.forEach(el => {
        if (originalComponent.name === el.name && originalComponent.id !== el.id &&
          !(originalComponent.componentType === 'rc-label' && el.componentType === 'rc-label') &&
          !(originalComponent.componentType === 'rc-layout' && el.componentType === 'rc-layout')) {
          throw new Error(`${el.name}控件存在同名。`)
        }
        // 判断是否是表格控件 表格控件中也要判重
        if (el.children && el.children.length && el.children.length > 0) {
          this.checkNameRepeat(el.children)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.component-attr-panel {
  height: 100%;
  .el-tabs__nav {
    overflow: hidden;
    .el-tabs__item {
      float: left;
      width: 50%;
    }
  }
  .component-attr {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 84px;
  }
  .btns {
    width: 240px;
    height: 80px;
    position: absolute;
    left: 50%;
    bottom: 0;
    margin-left: -112px;
    margin-bottom: 1px;
    padding-top: 27px;
    background: #fff;
    z-index: 10;
    border-radius: 3px;
    text-align: center;
    .save,
    .close {
      width: 78px;
      height: 26px;
      padding: 0;
    }
  }

  .controlTypeName {
    position: absolute;
    top: 0;
    left: 9px;
    overflow: hidden;
    text-align: center;
    line-height: 39px;
    height: 39px;
    width: 240px;
    z-index: 200;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-top: 1px solid #ddd;
    border-bottom: 2px solid #409EFF;
    color: #409EFF;
    background-color: #EBF6FF
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/design/component-attr.vue